import React, { FC } from 'react';
import Link from 'next/link';
import { MatchingChallengeCardVO } from '@domain/vo/challenge/MatchingChallengeListVO';
import { ChallengeStatus } from '@domain/constant/challenge/challengeStatusType';
import { V2Route } from '@utils/routeUtil/V2Route';

import classnames from 'classnames/bind';
import styles from './challengeList.module.scss';
const cx = classnames.bind(styles);

interface ChallengeCardProps {
  challenge: MatchingChallengeCardVO;
}

const ChallengeCard = ({ challenge }: ChallengeCardProps) => {
  const isCompany = challenge.type === 'COMPANY';
  const status = Object.keys(ChallengeStatus).filter((statusType) => statusType === challenge.challengeStatus);

  return (
    <li key={challenge.sn} className={cx('listItem')}>
      <Link href={V2Route.getChallengePage(challenge.sn)} legacyBehavior>
        <a className={cx('link')} role="button">
          <div className={cx('imgArea')}>
            <div className={cx('imgWrap')} style={{ backgroundImage: `url('${challenge.bannerImageUrl}')` }} />
          </div>
          <div className={cx('infoArea')}>
            <div className={cx('date', ...status)}>
              <div className={cx('dateWrap')}>
                {challenge.challengeStatusText}
                <br />-<br />
                {challenge.postEndDateTimeMMddForm}
              </div>
            </div>
            <div className={cx('textArea')}>
              <strong className={cx('title')}>{challenge.title}</strong>
              <div className={cx('participationArea')}>
                {isCompany ? (
                  <>
                    <span className={cx('participationTitle')}>참여 기업</span>
                    {challenge.participants}
                  </>
                ) : (
                  <>
                    <span className={cx('participationTitle')}>참여 포지션</span>
                    {challenge.participants}
                  </>
                )}
              </div>
              <div className={cx('text')}>{challenge.description}</div>
            </div>
          </div>
        </a>
      </Link>
    </li>
  );
};

interface ChallengeListProps {
  challengeListData: MatchingChallengeCardVO[];
}

const ChallengeList: FC<ChallengeListProps> = ({ challengeListData }) => {
  const listItem = challengeListData.map((challenge) => <ChallengeCard key={challenge.sn} challenge={challenge} />);

  return (
    <div className={cx('challengeListArea')}>
      <ul className={cx('challengeList')}>{listItem}</ul>
    </div>
  );
};

export default ChallengeList;
